import Field from './Field'

const PickupField = ({
  pickup,
  onChange,
}: {
  pickup: boolean
  onChange: (newPickup: boolean) => void
}) => (
  <Field
    label="Delivery Method"
    desc={
      <>
        <p>Select pickup if the customer is picking up the order directly from your location.</p>
        <p>
          <span className="font-medium">Note:</span> selecting pickup removes the shipping cost.
        </p>
      </>
    }
  >
    <div className="space-y-4 sm:flex sm:items-center sm:space-y-0 sm:space-x-10">
      <div className="flex items-center gap-2">
        <input
          id="ship"
          name="notification-method"
          type="radio"
          checked={!pickup}
          className="h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-500"
          onChange={(e) => e.target.checked && onChange(false)}
        />
        <label htmlFor="ship" className="block text-sm font-medium">
          Ship
        </label>
      </div>
      <div className="flex items-center gap-2">
        <input
          id="pickup"
          name="notification-method"
          type="radio"
          checked={pickup}
          className="h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-500"
          onChange={(e) => e.target.checked && onChange(true)}
        />
        <label htmlFor="pickup" className="block text-sm font-medium">
          Pickup
        </label>
      </div>
    </div>
  </Field>
)

export default PickupField
